function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { KeyboardMixin } from '@vaadin/a11y-base/src/keyboard-mixin.js';
import { isTouch } from '@vaadin/component-base/src/browser-utils.js';
import { InputMixin } from './input-mixin.js';
/**
 * A mixin that manages the clear button.
 *
 * @polymerMixin
 * @mixes InputMixin
 * @mixes KeyboardMixin
 */

export var ClearButtonMixin = function ClearButtonMixin(superclass) {
  return /*#__PURE__*/function (_InputMixin) {
    _inherits(ClearButtonMixinClass, _InputMixin);

    var _super = _createSuper(ClearButtonMixinClass);

    function ClearButtonMixinClass() {
      _classCallCheck(this, ClearButtonMixinClass);

      return _super.apply(this, arguments);
    }

    _createClass(ClearButtonMixinClass, [{
      key: "clearElement",
      get:
      /**
       * Any element extending this mixin is required to implement this getter.
       * It returns the reference to the clear button element.
       *
       * @protected
       * @return {Element | null | undefined}
       */
      function get() {
        console.warn("Please implement the 'clearElement' property in <".concat(this.localName, ">"));
        return null;
      }
      /** @protected */

    }, {
      key: "ready",
      value: function ready() {
        var _this = this;

        _get(_getPrototypeOf(ClearButtonMixinClass.prototype), "ready", this).call(this);

        if (this.clearElement) {
          this.clearElement.addEventListener('mousedown', function (event) {
            return _this._onClearButtonMouseDown(event);
          });
          this.clearElement.addEventListener('click', function (event) {
            return _this._onClearButtonClick(event);
          });
        }
      }
      /**
       * @param {Event} event
       * @protected
       */

    }, {
      key: "_onClearButtonClick",
      value: function _onClearButtonClick(event) {
        event.preventDefault();

        this._onClearAction();
      }
      /**
       * @param {MouseEvent} event
       * @protected
       */

    }, {
      key: "_onClearButtonMouseDown",
      value: function _onClearButtonMouseDown(event) {
        event.preventDefault();

        if (!isTouch) {
          this.inputElement.focus();
        }
      }
      /**
       * Override an event listener inherited from `KeydownMixin` to clear on Esc.
       * Components that extend this mixin can prevent this behavior by overriding
       * this method without calling `super._onEscape` to provide custom logic.
       *
       * @param {KeyboardEvent} event
       * @protected
       * @override
       */

    }, {
      key: "_onEscape",
      value: function _onEscape(event) {
        _get(_getPrototypeOf(ClearButtonMixinClass.prototype), "_onEscape", this).call(this, event);

        if (this.clearButtonVisible && !!this.value) {
          event.stopPropagation();

          this._onClearAction();
        }
      }
      /**
       * Clears the value and dispatches `input` and `change` events
       * on the input element. This method should be called
       * when the clear action originates from the user.
       *
       * @protected
       */

    }, {
      key: "_onClearAction",
      value: function _onClearAction() {
        this._inputElementValue = ''; // Note, according to the HTML spec, the native change event isn't composed
        // while the input event is composed.

        this.inputElement.dispatchEvent(new Event('input', {
          bubbles: true,
          composed: true
        }));
        this.inputElement.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * Set to true to display the clear icon which clears the input.
           *
           * It is up to the component to choose where to place the clear icon:
           * in the Shadow DOM or in the light DOM. In any way, a reference to
           * the clear icon element should be provided via the `clearElement` getter.
           *
           * @attr {boolean} clear-button-visible
           */
          clearButtonVisible: {
            type: Boolean,
            reflectToAttribute: true,
            value: false
          }
        };
      }
    }]);

    return ClearButtonMixinClass;
  }(InputMixin(KeyboardMixin(superclass)));
};